export function normalizeLegacyBoxOverlayData(theData) {
  const newData = JSON.parse(JSON.stringify(theData));
  // fBoxFillColor2` becomes fBoxFillColorGradient in 2.0
  if ("fBoxFillColor2" in newData) {
    newData.fBoxFillColorGradient = newData.fBoxFillColor2;
    delete newData.fBoxFillColor2;
  }
  return newData;
}
